<template>
  <v-tabs v-model="tab">
    <slot />
  </v-tabs>
  <v-tabs-window v-model="tab">
    <slot name="content" />
  </v-tabs-window>
</template>

<script>
export default {
  name: 'BTabs',
  data () {
    return { tab: 0 }
  }
}
</script>
